<template>
  <v-layout row>
    <v-flex>
      <nx-tag-selector
        :label="label"
        :data-vv-name="name"
        :data-vv-scope="scope"
        :data-vv-as="label"
        :value="value"
        :auth="auth"
        :disabled="disabled"
        v-bind="$attrs"
        v-validate:value="validation"
        data-vv-validate-on="input|blur"
        :error-messages="errorMessages"
        :required="required"
        @authorized="$emit('authorized', $event)"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
      ></nx-tag-selector>
    </v-flex>
  </v-layout>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import Selector from './TagSelector';

/**
 * Taxonomy Selector.
 *
 * @property {number} [limit] Maximun number of taxonomies that can be selected.
 * @property {(TaxonomyCard|TaxonomyCard[])} [value] The initial selected taxonomies.
 * @property {[]} [type] Taxonomy types allowed in the module.
 */
export default {
  name: 'nx-tag-form-selector',
  mixins: [FormElement],
  components: {
    [Selector.name]: Selector,
  },
  props: {
    value: {
      type: [Array, Object, Number],
    },
    auth: {
      type: Object,
      default() {
        return {
          actions: {
            ADD: null, // Specify bbnx operation when adding tags for validation
            DELETE: null, // Specify bbnx operation when removing current tags
            CREATE: null, // Specify bbnx operation when creating new tags
          },
          params: {}, // Object of params that will be sent to bbnx to validate action
        };
      },
    },
  },
  methods: {
    onInput(value) {
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
    },
    onBlur(blurValue) {
      this.flags.focused = false;
      this.$emit('blur', blurValue);
    },
  },
};
</script>
